
import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { DataService, Drug } from '../data.service';
import { FormGroup, FormsModule, Validators } from '@angular/forms';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { HomeService } from '../../home/home.services';

@Component({
  selector: 'app-drug-modal',
  templateUrl: './drug-modal.component.html',
  styleUrls: ['./drug-modal.component.scss'],
})
export class DrugModalComponent implements OnInit {
  showModal = false;
  isEditMode = false;
  editItem: any = null;
  public Editor = ClassicEditor;
  brandname = '';
  MoleculeData1: any = [];
  submolecules: any[] = [];
  nda_number: any;
  subMolecule = false;
  Molecule = false;
  DragData: any = {};
  selectedSubMolecule: any = {};
  filters: any = {};
  years = Array.from({ length: 100 }, (_, i) => 2000 + i);
  public editorConfig = {
    toolbar: [
      'heading', '|', 'bold', 'italic', 'underline', '|',
      'link', 'bulletedList', 'numberedList', 'blockQuote', '|',
      'insertTable', 'imageUpload', 'undo', 'redo', '|',
      'fontColor', 'fontBackgroundColor'   // 👈 add these
    ]
  };
  // Field disabling configuration - fields disabled for each category
  private categoryDisabledFields: { [key: string]: string[] } = {
    'New Indication': ['drugName', 'activeIngredient', 'companyName', 'routeOfAdministration', 'dosageForm', 'strength', 'dosingRegimen'],
    'New Strength': ['drugName', 'activeIngredient', 'companyName', 'routeOfAdministration', 'dosageForm', 'dosingRegimen'],
    'New Route / New Dosage Form': ['drugName', 'activeIngredient', 'companyName', 'strength', 'dosingRegimen'],
    'New Recommended Dose / Regimen': ['drugName', 'activeIngredient', 'companyName', 'routeOfAdministration', 'dosageForm', 'strength'],
    'New Population': ['drugName', 'activeIngredient', 'companyName', 'routeOfAdministration', 'dosageForm', 'strength']
  };

  arrayToDropdown(InputArray: any) {
    let DropDownArray = [];
    InputArray.forEach((DropdownValues: any) => {
      let dropDownObj = {
        name: `${DropdownValues.brand_name},${DropdownValues.nda_number},${DropdownValues.dosage_forms}`,
        code: DropdownValues // store the full object for later use
      };
      DropDownArray.push(dropDownObj);
    });
    return DropDownArray;
  }
  drugForm = new FormGroup<any>({
    drugName: new FormControl(''),
    activeIngredient: new FormControl(''),
    companyName: new FormControl(''),
    indication: new FormControl(''),
    pdufaDate: new FormControl(''),
    fillingDate: new FormControl(''),
    acceptanceDate: new FormControl(''),
    quarterSelection: new FormControl(''),
    statusSelection: new FormControl(''),
    routeOfAdministration: new FormControl(''),
    dosageForm: new FormControl(''),
    strength: new FormControl(''),
    dosingRegimen: new FormControl(''),
    designations: new FormControl([]), // Array for multiple selections
    // padufa: new FormControl(''),
    peakSales: new FormControl(''),
    comments: new FormControl(''),
    quarterSelectionYear: new FormControl(''),
    population: new FormControl(''),

  });
  designationTags: string[] = [];
  selectedDesignations: string[] = [];
  constructor(
    private toastr: ToastrService,
    private dashboardService: DashboardService,
    private dataService: DataService,
    private router: Router,
    private homeservice: HomeService

  ) { }

  ngOnInit() {
    this.drugForm.get('activeIngredient')?.enable();
    this.drugForm.get('companyName')?.enable();
    this.drugForm.get('dosageForm')?.enable();
    this.dashboardService.pdufaInformation$.subscribe(val => {
      console.log("val=======", val);
      this.designationTags = val?.designation_tags || [];

    });
    this.dashboardService.showDrugModal$.subscribe(show => {
      this.showModal = show;
      if (show) {
        if (this.isEditMode && this.editItem) {
          // In edit mode, populate form with existing data
          this.populateFormForEdit(this.editItem);
        } else {
          // In add mode, reset form
          this.resetForm();
        }
      }
    });

    this.dashboardService.editMode$.subscribe(editMode => {
      this.isEditMode = editMode;
    });

    this.dashboardService.editItem$.subscribe(item => {
      this.editItem = item;
      if (item && this.isEditMode) {
        this.populateFormForEdit(item);
      }
    });
    this.dashboardService.filters$.subscribe(filters => {
      console.log("filters=======", filters);
      this.filters = filters;
      // Ensure sNDA specific old* controls exist when needed
      this.ensureSndaOldFieldsPresence(this.filters?.type === 'sNDA');
      // Update field disabling based on selected categories
      // this.updateFieldDisabling();
    });
  }

  closeModal() {
    this.dashboardService.closeDrugModal();
  }

  private ensureSndaOldFieldsPresence(isSnda: boolean) {
    const controls = [
      'oldrouteOfAdministration',
      'olddosageForm',
      'oldstrength',
      'olddosingRegimen',
      'oldindication',
    ];
    if (isSnda) {
      controls.forEach(name => {
        if (!this.drugForm.contains(name)) {
          this.drugForm.addControl(name, new FormControl(''));
        }
      });
    } else {
      controls.forEach(name => {
        if (this.drugForm.contains(name)) {
          this.drugForm.removeControl(name);
        }
      });
    }
  }

  onSubmit() {
    let userEmail = localStorage.getItem('email');
    if (this.drugForm.valid) {
      const formatSaveDate = (val: any) => {
        if (!val) return null;
        const d = new Date(val);
        if (isNaN(d.getTime())) return val;
        return { "$date": val };
      };

      if (this.isEditMode && this.editItem) {
        // Edit mode - get current filter values
        const filters = this.dashboardService.getFilters();
        const updateData: any = {
          _id: this.editItem._id,
          // Use current filter values
          application_type: filters.type,
          categories: filters.type === 'sNDA' ? filters.categories : [filters.category],
          therapeutic_categories: filters?.therapeuticArea?.split(',') || [],

          // Use form values for drug details
          drug_name: this.drugForm.value.drugName,
          active_ingredient: this.drugForm.value.activeIngredient,
          company_name: this.drugForm.value.companyName,
          route_of_administration: this.drugForm.value.routeOfAdministration,
          dosage_form: this.drugForm.value.dosageForm,
          strength: this.drugForm.value.strength,
          dosing_regimen: this.drugForm.value.dosingRegimen,
          indication: this.drugForm.value.indication,
          pdufa_date: formatSaveDate(this.drugForm.value.pdufaDate),
          filling_date: formatSaveDate(this.drugForm.value.fillingDate),
          acceptance_date: formatSaveDate(this.drugForm.value.acceptanceDate),
          quarter_selection: this.drugForm.value.quarterSelection,
          pdufa_status: this.drugForm.value.statusSelection,
          peak_sales: this.drugForm.value.peakSales,
          comments: this.drugForm.value.comments,
          designation_tags: this.selectedDesignations,
          user_email: userEmail,
          publish: false,
          quarter_year: this.drugForm.value.quarterSelectionYear,
          // pdufa_comments:this.drugForm.value.padufa,
        };

        // Include old* fields for sNDA
        if (filters.type === 'sNDA') {
          updateData.old_route_of_administration = this.drugForm.value['oldrouteOfAdministration'] || '';
          updateData.old_dosage_form = this.drugForm.value['olddosageForm'] || '';
          updateData.old_strength = this.drugForm.value['oldstrength'] || '';
          updateData.old_dosing_regimen = this.drugForm.value['olddosingRegimen'] || '';
          updateData.old_indication = this.drugForm.value['oldindication'] || '';
        }

        // Add sub_categories if category is EAM
        if ((filters.category === 'Existing Active Moiety (EAM)' || filters?.categories?.includes('Existing Active Moiety (EAM)')) && (filters.subCategory || filters.subCategories)) {
          updateData.sub_categories = {
            'Existing Active Moiety (EAM)': filters?.subCategories
          };
        } else {
          updateData.sub_categories = {};
        }


        // if(this.DragData && filters.type === 'sNDA'){
        //   updateData.mapped_nda = this.DragData;
        // }

        this.dashboardService.updateDrug(updateData).subscribe((res) => {
          this.toastr.success('Drug updated successfully!');
          window.location.reload();
          this.closeModal();
        });
      } else {
        // Add mode
        const filters = this.dashboardService.getFilters();
        console.log("this.drugForm.value", this.drugForm.value)
        console.log("filters 63******", this.drugForm.value)
        console.log("selectedDesignations", this.selectedDesignations)

        this.dashboardService.filters$.subscribe(filters => {
          console.log("filters 65******", filters)
          let newDrug: any = {
            "categories": filters.type === 'sNDA' ? filters.categories : [filters.category],
            "drug_name": this.drugForm.value.drugName,
            "active_ingredient": this.drugForm.value.activeIngredient,
            "company_name": this.drugForm.value.companyName,
            "application_type": filters.type,
            "route_of_administration": this.drugForm.value.routeOfAdministration,
            "dosage_form": this.drugForm.value.dosageForm,
            "strength": this.drugForm.value.strength,
            "therapeutic_categories": filters?.therapeuticArea?.split(',') || [],
            "dosing_regimen": this.drugForm.value.dosingRegimen,
            "indication": this.drugForm.value.indication,
            "pdufa_date": formatSaveDate(this.drugForm.value.pdufaDate),
            "filling_date": formatSaveDate(this.drugForm.value.fillingDate),
            "acceptance_date": formatSaveDate(this.drugForm.value.acceptanceDate),
            "quarter_selection": this.drugForm.value.quarterSelection,
            "pdufa_status": this.drugForm.value?.statusSelection || null,
            "peak_sales": this.drugForm?.value?.peakSales || null,
            "comments": this.drugForm?.value?.comments || null,
            "designation_tags": this.selectedDesignations,
            "user_email": userEmail,
            publish: false,
            quarter_year: this.drugForm.value?.quarterSelectionYear || null,
            // pdufa_comments:this.drugForm.value.padufa,
          };
          // Include old* fields for sNDA
          if (filters.type === 'sNDA') {
            newDrug.old_indication = this.drugForm.value?.['oldindication'] || '';
            newDrug.old_route_of_administration = this.drugForm.value?.['oldrouteOfAdministration'] || '';
            newDrug.old_dosage_form = this.drugForm.value?.['olddosageForm'] || '';
            newDrug.old_strength = this.drugForm.value['oldstrength'] || '';
            newDrug.old_dosing_regimen = this.drugForm.value?.['olddosingRegimen'] || '';
          }
          // if(this.DragData && filters.type === 'sNDA'){
          //   newDrug.mapped_nda =this.DragData
          // }
          if (filters.category === "Existing Active Moiety (EAM)") {
            newDrug.sub_categories = {
              "Existing Active Moiety (EAM)": filters?.subCategories
            }
          }
          else {
            newDrug.sub_categories = [];
          }

          this.dashboardService.saveDrug(newDrug).subscribe((res) => {
            console.log("res=======", res)
            this.toastr.success('Drug added successfully!');
            // if(res.status === 200){
            window.location.reload();
            // }
            // else {
            //   this.toastr.error('Drug added failed!');
            // }
            this.closeModal();
          }, (error) => {
            console.log("error=======", error)
            this.toastr.error('Drug added failed!');
          })
        })
      }
    }

    // this.closeModal();
    // this.dataService.saveDrug(newDrug).subscribe(() => {
    //   // Refresh results would happen automatically due to reactive data
    // });
  }

  private resetForm() {
    this.drugForm.reset();
    this.selectedDesignations = [];
  }

  private populateFormForEdit(item: any) {
    console.log("item", item)

    const formatDate = (dateVal: any) => {
      if (!dateVal) return '';
      const dStr = (typeof dateVal === 'object' && dateVal.$date) ? dateVal.$date : dateVal;
      const d = new Date(dStr);
      if (isNaN(d.getTime())) return dStr; // Return raw string for formats like "Q2, 2025"
      return new Date(d.getTime() + 24 * 60 * 60 * 1000).toISOString().split('T')[0];
    };

    this.drugForm.patchValue({
      drugName: item.drug_name || '',
      activeIngredient: item.active_ingredient || '',
      companyName: item.company_name || '',
      routeOfAdministration: item.route_of_administration || '',
      dosageForm: item.dosage_form || '',
      strength: item.strength || '',
      dosingRegimen: item.dosing_regimen || '',
      indication: item.indication || '',
      pdufaDate: formatDate(item.pdufa_date),
      fillingDate: formatDate(item.filling_date),
      acceptanceDate: formatDate(item.acceptance_date),
      statusSelection: item.pdufa_status || '',
      peakSales: item.peak_sales || '',
      comments: item.comments || '',
      // padufa:item.pdufa_comments || '', 
      quarterSelection: item.quarter_selection || '',
      quarterSelectionDate: formatDate(item.quarter_selection_date),
      oldactiveIngredient: item.oldactiveIngredient || '',
      quarterSelectionYear: item.quarter_year || '',
    });
    // Patch sNDA old* fields if present and controls exist
    const oldFields = {
      oldrouteOfAdministration: item.old_route_of_administration || '',
      olddosageForm: item.old_dosage_form || '',
      oldstrength: item.old_strength || '',
      olddosingRegimen: item.old_dosing_regimen || '',
      oldindication: item.old_indication || '',
    } as any;
    Object.keys(oldFields).forEach(key => {
      if (this.drugForm.contains(key)) {
        this.drugForm.patchValue({ [key]: oldFields[key] });
      }
    });

    // Set selected designations
    this.selectedDesignations = item.designation_tags || [];
    this.drugForm.patchValue({ designations: this.selectedDesignations });
  }

  // Handle designation checkbox changes
  onDesignationChange(designation: string, event: any) {
    if (event.target.checked) {
      if (!this.selectedDesignations.includes(designation)) {
        this.selectedDesignations.push(designation);
      }
    } else {
      const index = this.selectedDesignations.indexOf(designation);
      if (index > -1) {
        this.selectedDesignations.splice(index, 1);
      }
    }
    // Update the form control with the array of selected designations
    this.drugForm.patchValue({ designations: this.selectedDesignations });
  }

  // Check if a designation is selected
  isDesignationSelected(designation: string): boolean {
    return this.selectedDesignations.includes(designation);
  }
  searchMolecule() {
    console.log("searchMolecule")
    this.homeservice.GetNda(this.brandname).subscribe((response) => {
      this.MoleculeData1 = response["data"].nda_numbers;
      if (this.MoleculeData1 != null) {
        let dropdownvalues = this.arrayToDropdown(this.MoleculeData1);
        this.submolecules = dropdownvalues;
        console.log("submolecules", this.submolecules)
        const Array = this.submolecules[0].name.split(",")[1];
        this.nda_number = Array;
        this.subMolecule = true;
        this.Molecule = false;
        this.DragData = {};
      } else {
        this.selectedSubMolecule = {};
        this.subMolecule = false;
        this.Molecule = false;
        this.DragData = {};
      }
    });
  }
  getData() {
    console.log("getData", (this.selectedSubMolecule))
    if (this.selectedSubMolecule !== undefined) {
      let selectedMoleculeData = this.selectedSubMolecule["code"];
      console.log("selectedMoleculeData", selectedMoleculeData)
      if (selectedMoleculeData) {
        this.dashboardService.getDrugData(selectedMoleculeData).subscribe((res) => {
          this.DragData = res;
          console.log("res", res)
          // this.drugForm.patchValue({
          //   activeIngredient: res["Active Ingredient"],
          //   companyName: res["Brand Name/Proprietary Name"],
          //   dosageForm: res["Dosage forms"],
          // })
        }, (error) => {
          console.log("error", error)
        })
      }
    }
  }
  clearData() {
    this.drugForm.reset();
  }

  /**
   * Updates field disabling based on selected categories
   */
  private updateFieldDisabling() {
    if (!this.filters) return;

    // Get selected categories
    const selectedCategories = this.getSelectedCategories();
    console.log('Selected categories for field disabling:', selectedCategories);

    if (selectedCategories.length === 0) {
      // No categories selected, enable all fields
      console.log('No categories selected, enabling all fields');
      // this.enableAllFields();
      return;
    }

    // Calculate disabled fields for all selected categories
    const disabledFields = this.calculateDisabledFields(selectedCategories);
    console.log('Calculated disabled fields:', disabledFields);

    // Apply field disabling
    // this.applyFieldDisabling(disabledFields);
  }

  /**
   * Gets the currently selected categories
   */
  private getSelectedCategories(): string[] {
    if (this.filters.type === 'sNDA' && this.filters.categories) {
      return Array.isArray(this.filters.categories) ? this.filters.categories : [this.filters.categories];
    } else if (this.filters.category) {
      return [this.filters.category];
    }
    return [];
  }

  /**
   * Calculates which fields should be disabled based on selected categories
   * Uses INTERSECTION logic: fields are disabled only if they are disabled in ALL selected categories
   */
  private calculateDisabledFields(selectedCategories: string[]): string[] {
    console.log('=== Multiple Category Field Disabling Logic (INTERSECTION) ===');
    console.log('Selected categories:', selectedCategories);

    if (selectedCategories.length === 0) {
      console.log('No categories selected, no fields disabled');
      return [];
    }

    if (selectedCategories.length === 1) {
      // Single category - use its disabled fields directly
      const singleCategory = selectedCategories[0];
      const disabledFields = this.categoryDisabledFields[singleCategory] || [];
      console.log(`Single category "${singleCategory}" disables fields:`, disabledFields);
      return disabledFields;
    }

    // Multiple categories - find intersection of disabled fields
    const allDisabledFields = selectedCategories.map(category => {
      const fields = this.categoryDisabledFields[category] || [];
      console.log(`Category "${category}" disables fields:`, fields);
      return fields;
    });

    // Find intersection - fields that are disabled in ALL categories
    const intersection = allDisabledFields.reduce((acc, currentFields) => {
      return acc.filter(field => currentFields.includes(field));
    });

    console.log('Intersection of disabled fields (disabled in ALL categories):', intersection);
    console.log('=== End Field Disabling Logic ===');

    return intersection;
  }

  /**
   * Applies field disabling to the form
   */
  private applyFieldDisabling(disabledFields: string[]) {
    // First enable all fields
    this.enableAllFields();

    // Then disable the specified fields
    disabledFields.forEach(fieldName => {
      const control = this.drugForm.get(fieldName);
      if (control) {
        control.disable();
        console.log(`Disabled field: ${fieldName}`);
      }
    });
  }

  /**
   * Enables all form fields
   */
  private enableAllFields() {
    const fieldNames = ['drugName', 'activeIngredient', 'companyName', 'routeOfAdministration', 'dosageForm', 'strength', 'dosingRegimen'];
    fieldNames.forEach(fieldName => {
      const control = this.drugForm.get(fieldName);
      if (control) {
        control.enable();
      }
    });
  }

  /**
   * Checks if a field should be disabled based on current category selection
   */
  isFieldDisabled(fieldName: string): boolean {
    const selectedCategories = this.getSelectedCategories();
    if (selectedCategories.length === 0) return false;

    const disabledFields = this.calculateDisabledFields(selectedCategories);
    const isDisabled = disabledFields.includes(fieldName);

    // Only log when field is actually disabled to reduce console noise
    if (isDisabled) {
      console.log(`Field "${fieldName}" is DISABLED due to categories:`, selectedCategories);
    }

    return isDisabled;
  }

  /**
   * Gets the currently selected categories for display purposes
   */
  getSelectedCategoriesForDisplay(): string[] {
    return this.getSelectedCategories();
  }

  /**
   * Test method to verify intersection logic with the provided examples
   */

}